import { yup } from '@framework/validation/initYup.ts';

export const allowedFormats = [
  {
    label: 'Email',
    value: 'email',
    schema: yup.string().required().email(),
  },
  {
    label: 'Codice Fiscale',
    value: 'fiscalCode',
    schema: yup.string().required().fiscalNumber(),
  },
  {
    label: 'Partita IVA',
    value: 'vatNumber',
    schema: yup.string().required().vatNumber(),
  },
] as const;

export type AllowedFormat = (typeof allowedFormats)[number]['value'];

export function isValueMatchingFormat(value: any, target: any): boolean {
  if (typeof target !== 'string' || target == null) return false;

  const format = allowedFormats.find(f => f.value === target)?.schema;

  if (format == null) return false;

  if (value == null) return false;

  if (typeof value !== 'string' || value.trim() === '') return false;

  return format.isValidSync(value);
}
